import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { tryNow } from "../../utils";

export const CommonBanner = (props) => {
  const { title, subtitle, imgurl, children, docLink } = props;
  const { t } = useTranslation();
  const docLinkEvent = () => {
    window.open(docLink);
  };
  return (
    <section>
      <div className="authing-banner-warp">
        <div className="banner">
          <div className="banner-img">
            {imgurl && (
              <img
                src={`//files.authing.co/authing-website${imgurl}`}
                alt="authing banner"
              />
            )}
            {children}
          </div>
          <div className="banner-content">
            <div className="banner-title">{title}</div>
            <div className="banner-subtitle">{subtitle}</div>
            <div style={{ display: "flex" }}>
              <div className="banner-button" onClick={tryNow}>
                {t("common.button.try-now")}
              </div>
              {docLink ? (
                <div className="banner-button-unfilled" onClick={docLinkEvent}>
                  {t("common.linkDoc")}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="authing-banner-bg"></div>
      </div>
    </section>
  );
};
